import React from "react";

function SelectorIcon({ activated, selected, Icon, handleChatIcon }: any) {
  return (
    <div
      className={`flex h-9 items-center justify-center rounded-full px-5 text-lg transition-colors duration-200 ${
        selected
          ? "bg-[#F30543] text-white shadow-[0_2px_10px_rgba(243,5,67,0.4)]"
          : activated
          ? "cursor-pointer text-white/70 hover:text-white"
          : "text-white/25"
      }`}
      onClick={handleChatIcon}
    >
      {Icon}
    </div>
  );
}

export default SelectorIcon;